import { render, staticRenderFns } from "./BusSewage.vue?vue&type=template&id=4b0626cf&"
import script from "./BusSewage.vue?vue&type=script&lang=js&"
export * from "./BusSewage.vue?vue&type=script&lang=js&"
import style0 from "./BusSewage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports